/**
 * Helper to build a reducer
 * @param {Object} initialState 
 * @param {Map} handlers
 * @return {Func} a redux reducer
 */
export const createReducer = (initialState, handlers) => {
  return (state=initialState, action) => {
    const handler = handlers[action.type]
    return handler ? handler(state, action) : state
  }
}



// WEBPACK FOOTER //
// ./src/utils.js